export { MB_PageIndicator } from './src/page-indicator';
export type { MB_PageIndicatorProps } from './src/page-indicator';

// TODO: Anas: Add pageIndicator to MB_Table documentation.